module.exports = __webpack_public_path__ + "static/media/home-solid.fa2c07da.svg";